// Components/ProtectedRoute.tsx
import { Navigate, Outlet } from "react-router-dom";
import { useEffect } from "react";

interface ProtectedRouteProps {
  isAuthRoute?: boolean;
  redirectPath?: string;
}

function ProtectedRoute({ isAuthRoute = false, redirectPath = "/" }: ProtectedRouteProps) {
  const token = localStorage.getItem("token");

  useEffect(() => {
    // Force reload when redirecting logged-in user from auth routes
    if (isAuthRoute && token) {
      window.location.href = redirectPath;
    }
  }, [isAuthRoute, token, redirectPath]);

  // For auth routes, return null while redirecting to prevent flash of content
  if (isAuthRoute && token) {
    return null;
  }

  // For protected routes that require authentication
  if (!isAuthRoute && !token) {
    return <Navigate to="/Login" replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;